import { FC, useState } from 'react';
import {
  usePutDriverMutation,
  useDeliteDriverMutation,
  useGetDriverSkillLevelsQuery,
  useGetDriverLicensesQuery,
} from '../../../../api/driverApi';
import { extinctNullFromParams } from '../../../../api/nullExtict';
import Button from '../../../../components/common/Button';
import MenuButton from '../../../../components/common/MenuButton';
import Modal from '../../../../components/common/Modal';
import PolicyRequired from '../../../../components/common/PolicyRequired';
import { Driver } from '../../../../types/driver';
import { DriverFormDataProviderProps } from '../EditSideBar';
import styles from './styles.module.css';
import { logger } from '../../../../services/logger';

type Props = {
  driver: Driver;
  openEdit: (props: DriverFormDataProviderProps | null) => void;
  sidebarClose: () => void;
};
const TableMenuButton: FC<Props> = ({ driver, openEdit, sidebarClose }) => {
  const [deleteDriver] = useDeliteDriverMutation();
  const [editDriver] = usePutDriverMutation();
  const deleteModalContent = (close: () => void) => (
    <div>
      <h3 className={styles.modalHead}>本当に削除しますか？</h3>
      <div className={styles.content}>
        <div className={styles.text}>
          削除すると、元に戻すことはできません。
        </div>
        <div className={styles.controls}>
          <div className={styles.button}>
            <Button variants={['cancel', 'fit']} onClick={close}>
              キャンセル
            </Button>
          </div>
          <div className={styles.button}>
            <Button
              variants={['fit']}
              onClick={async () => {
                await deleteDriver(driver.userId);
                close();
              }}
            >
              確定
            </Button>
          </div>
        </div>
      </div>
    </div>
  );

  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const { data: skillLevelTypes = [] } = useGetDriverSkillLevelsQuery();
  const { data: licenseTypes = [] } = useGetDriverLicensesQuery();

  return (
    <>
      <MenuButton>
        {({ close, itemClassName }) => (
          <>
            <PolicyRequired policy={4}>
              <button
                type="button"
                className={itemClassName}
                onClick={() => {
                  openEdit({
                    formData: {
                      driverName: driver.driverName,
                      skillLevelId:
                        driver.skillLevel?.id ??
                        skillLevelTypes[0]?.skillLevelId,
                      driverLicenseId:
                        driver.driverLicense?.id ??
                        licenseTypes[0]?.driverLicenseId,
                      carQualificationIds: !driver.carQualifications
                        ? []
                        : driver.carQualifications.map((i) => i.id),
                    },
                    onSubmit(data) {
                      editDriver({
                        userId: driver.userId,
                        data: extinctNullFromParams(data),
                      })
                        .unwrap()
                        .then(() => {
                          sidebarClose();
                        })
                        .catch(logger.error);
                    },
                  });
                  close();
                }}
              >
                編集
              </button>
            </PolicyRequired>
            <PolicyRequired policy={5}>
              <button
                type="button"
                className={itemClassName}
                onClick={() => {
                  openModal();
                  close();
                }}
              >
                削除
              </button>
            </PolicyRequired>
          </>
        )}
      </MenuButton>
      {modalOpen && (
        <Modal onRequestClose={closeModal}>
          {deleteModalContent(closeModal)}
        </Modal>
      )}
    </>
  );
};

export default TableMenuButton;
